import React from 'react';
import CV from '../../assets/cv.pdf';

const CTA = () => {
  return (
    <div className='cta'>
      <a href={CV} download className='btn'>
        Descargar CV
      </a>
      <a
        href='https://www.linkedin.com/in/adan-perez-rodriguez-6b6756256/'
        className='btn btn-primary'>
        Contacto
      </a>
    </div>
  );
};

export default CTA;
